<template>
  <div>
    <Breadcrumbs />
    <div class="wrapper mt-5 mb-5 pb-5 order-cancel">
      <div class="container ordercancel">
        <h1 class="mb-4 text-black">{{ $t("payment_cancel") }}</h1>
        <p class="page-tagline border-bottom border-black border-2 fs-5 pb-4">{{ $t("something_went_wrong") }}</p>
        <b-link @click.stop="goCart" class="btn btn-primary btn-big mx-auto mx-lg-0 ordercancel-btn">{{ $t("try_again") }}</b-link>
        <div class="row gx-5 gy-4 fs-5 lh-lg my-5 cancelorder-info">
          <div class="col-12 col-md-6 d-none d-md-block">
            <h2 class="h3 text-black mb-0">{{ $t("order_cancel_text_1") }}</h2>
          </div>
          <div class="col-12 col-md-6 d-none d-md-block">
            <h2 class="h3 text-black mb-0">{{ contactData.title }}</h2>
          </div>
          <div class="col-12 col-md-6">
            <h2 class="h3 text-black mb-0 mb-md-4 d-block d-md-none">{{ $t("order_cancel_text_1") }}</h2>
            <p>{{ $t("order_cancel_text_2") }} <b-link :to="{ name: 'home' }" class="link-with-underline">lederhosen</b-link>, <b-link :to="{ name: 'home' }" class="link-with-underline">dirndls</b-link> {{ $t("order_cancel_text_3") }} </p>
          </div>
          <div class="col-12 col-md-6" v-if="typeof contactData == 'object'">
            <h2 class="h3 text-black mb-4 d-block d-md-none">{{ contactData.title }}</h2>
            <cmsBlockSimple
              v-if="typeof contactData == 'object'"
              :identifier="contactData.identifier"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import SidebarLinks from "@/base/core/components/common/SidebarLinks.vue";
import { Logger } from "@storefront/core/lib/logger";
import Breadcrumbs from "@/esf_antarctica_lederhosenland/core/components/breadcrumb/Breadcrumbs.vue";
import cmsBlockSimple from "@/esf_antarctica_lederhosenland/core/components/common/BlockSimple.vue";

export default {
  name: "PaymentSuccess",
  components: {
    // SidebarLinks,
    Breadcrumbs,
    cmsBlockSimple
  },
  metaInfo() {
    return {
      meta: [
        { name: "title", content: this.$t("payment_cancel") },
        { name: "keywords", content: this.$t("payment_cancel") },
        { name: "description", content: this.$t("payment_cancel") },
      ],
      title: this.$t("payment_cancel"),
    };
  },
  computed: {
    transactionId() {
      if (typeof this.$store.state.route.query.transactionid != "undefined") {
        return this.$store.state.route.query.transactionid;
      }
      return null;
    },
    contactData() {
      return this.$store.getters[`cmsBlock/getCmsBlockByIdentifier`](
        "footer_contact"
      );
    },
  },
  mounted() {
    const bcrumb = { current: "Order cancelled", routes: [] };
    this.$store.commit("breadcrumbs/set", bcrumb);
    Logger.debug("router", "mounted", this.$store.state.route)();
  },
  methods: {
    goCart() {
      this.$router.push("/checkout/cart");
    },
  },
  data: () => ({
    sidebarData: {
      heading: "Categorie",
      options: [
        { displayName: "Gentlemen", linkTo: "#", active: false },
        { displayName: "Women", linkTo: "#", active: false },
        { displayName: "Bicycle clothing sets", linkTo: "#", active: false },
        { displayName: "Children", linkTo: "#", active: false },
        { displayName: "Cycling shoes", linkTo: "#", active: false },
        { displayName: "For your bike", linkTo: "#", active: false },
        { displayName: "For your body", linkTo: "#", active: false },
        { displayName: "Brands", linkTo: "#", active: false },
        { displayName: "Cycling books", linkTo: "#", active: false },
        { displayName: "Gift voucher", linkTo: "#", active: false },
      ],
    },
  }),
};
</script>

<style lang="scss" scoped>
h1 {
  margin-bottom: 16px;
}

ul {
  li {
    padding-left: 15px;
    position: relative;

    &:before {
      content: "";
      position: absolute;
      top: 12px;
      left: 1px;
      width: 4px;
      height: 4px;
      background: #000;
      border-radius: 100%;
    }
  }
}

.mb-lg-27 {
  margin-bottom: 27px;
}

.font-weight-medium {
  font-weight: 500;
}
</style>
